import { useState } from "react";

const DashboardHooks = () => {
  const [value, setValue] = useState("");

  const onChangeSearchBar = (e) => {
    setValue(e.target.value);
  };

  return { value, onChangeSearchBar };
};

export default DashboardHooks;
